export const iconFontAwesomeToggleToggleOn = (
	<i className="fa-solid fa-toggle-on"></i>
);
